export default __webpack_public_path__ + "static/media/3.Water-softner-plant.89af49cf.jpg";